import { jsonApiClient } from '@/httpConfig/config/axios';

// Cursor pagination only — handoff Section 9.1 explicitly rejects a `sort` param.
// `filter[wallet]` is the ONLY scalar filter (`['filled','string','exists:wallets,id']`);
// passing an array there yields "filter.wallet must be a string" 400, and a
// numeric walletId trips the same 400, so it is coerced to a string.
//
// `filter[kind]`, `filter[walletKind]` and `filter[status]` are all validated as
// ARRAYS (`['filled','array']` in TransactionCollectionQuery). Axios serializes an
// array value as repeated `filter[…][]=` params, which Laravel parses back into a
// list. A scalar is normalized to a one-element array so it satisfies the `array`
// rule — `filter[status]` used to be documented here as a scalar, which was true of
// an older contract and would 400 the whole request against the current one.
//
// `filter[walletKind]` (main | pool_share | pool_credit) scopes by WALLET FAMILY
// and is how the pool_credit tab pulls EVERY supplier wallet's transactions in
// one cursor stream — a member holds one `poolcredit_{supplierId}` wallet per
// supplier, so no single `filter[wallet]` id can cover that tab. `indexQuery`
// already scopes the endpoint to the member's own wallets, so passing
// `walletKind` with no `filter[wallet]` yields the whole supplier-credit ledger.
//
// This REPLACED an enumerate-the-`filter[kind]`-tokens approach that silently hid
// any row whose `meta.type` was missing from that hand-maintained list. A
// confirmed-delivered goodwill refund deposits onto a PoolCredit wallet as
// `meta.type = goodwill_refund` and was therefore reachable from NO tab at all.
// Never reintroduce a kind allow-list to scope the pool_credit tab.
export const transactionsService = {
  list: ({
    walletId,
    kind,
    kinds,
    walletKind,
    walletKinds,
    status,
    limit = 20,
    after,
    before,
  } = {}) => {
    const kindList = Array.isArray(kinds) && kinds.length > 0 ? kinds : kind ? [kind] : undefined;
    const walletKindList =
      Array.isArray(walletKinds) && walletKinds.length > 0
        ? walletKinds
        : walletKind
          ? [walletKind]
          : undefined;
    // `status` accepts either form at the call site; the wire always gets an array.
    const statusList = Array.isArray(status)
      ? status.length > 0
        ? status
        : undefined
      : status
        ? [status]
        : undefined;
    return jsonApiClient.get('/transactions', {
      params: {
        'filter[wallet]': walletId != null ? String(walletId) : undefined,
        'filter[kind]': kindList,
        'filter[walletKind]': walletKindList,
        'filter[status]': statusList,
        'page[limit]': limit,
        'page[after]': after,
        'page[before]': before,
      },
    });
  },

  // One ledger row by id — the same deserialized shape `list` yields per row, so it
  // drops straight into TransactionDetailSheet. The carton account's wallet rows
  // carry only a `transactionId`; this is how a tap on one opens the sheet.
  // `indexQuery`/the policy scope it to the member's own wallets.
  show: (id) => jsonApiClient.get(`/transactions/${id}`),
};
